import PropTypes from 'prop-types';
import { createContext, useEffect, useState } from 'react';
import { useContext } from 'react';

export const SwitchContext = createContext({
  value: null,
  setValue: () => {}
})

export function SwitchCase({
  value: defaultValue,
  children
}) {
  const [value, setValue] = useState(defaultValue)

  useEffect(() => {
    setValue(defaultValue)
  }, [defaultValue])

  return (
    <SwitchContext.Provider value={{ value }}>
      {children} 
    </SwitchContext.Provider>
  )
}

SwitchCase.propTypes = {
  value: PropTypes.any,
  children: PropTypes.node
}

export function Case({
  match,
  children
}) {
  const {
    value 
  } = useContext(SwitchContext)
  console.log("value", value)
  console.log("match", match)
  console.log("children", children)
  if (value === match) {
    return <>{children}</>
  } else {
    return null
  }
}

Case.propTypes = {
  match: PropTypes.any,
  children: PropTypes.node
}

export const ForContext = createContext({
  collection: null,
  i: 0
})

ForEach.propTypes = {
  collection: PropTypes.any,
  children: PropTypes.node,
  empty: PropTypes.node
}

export function ForEach({
  collection,
  children
}) {
  return (
    <ForContext.Provider value={{ collection }}>
      {children}
    </ForContext.Provider>
  )
}

ForEach.propTypes = {
  collection: PropTypes.any,
  children: PropTypes.node,
  empty: PropTypes.node
}

export function For({
  collection,
  children,
  empty
}) {
  return (
    <ForContext value={{ collection, empty }}>
      {children}
    </ForContext>
  )
}

For.propTypes = {
  collection: PropTypes.any,
  children: PropTypes.node,
  empty: PropTypes.node
}

export function Do({
  children
}) {
  const { collection } = useContext(ForContext)
  if (collection?.length > 0) {
    return collection.map((node, i) => children(node, i))
  }
  return null
}

Do.propTypes = {
  children: PropTypes.node
}

export function Empty({
  children
}) {
  const { collection } = useContext(ForContext)
  if (collection?.length > 0) {
    return null
  }
  return children
}

Empty.propTypes = {
  children: PropTypes.node
}

export function If({
  value,
  renderElse={},
  children
}) {
  if (value) {
    return children
  } else {
    return renderElse
  }
}

If.propTypes = {
  value: PropTypes.any,
  renderElse: PropTypes.node,
  children: PropTypes.node
}
